<div [style]="{ width: '600px', margin: '0 auto' }">
  <header>
    <h3>Create API Key</h3>
  </header>

  <h4>Key Name</h4>
  <input name="title" type="text" pInputText [(ngModel)]="apikey.title" />

  <footer>
    <button class="btn btn-primary" (click)="createKey()">Create key</button>
  </footer>
</div>
